import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArtigoGuiaCompleto from "../pages/artigo/cssbuy-spreadsheet-guia-completo/page";
import ArtigoComoUsar from "../pages/artigo/como-usar-cssbuy-2026/page";
import ArtigoSeguro from "../pages/artigo/cssbuy-e-seguro-confiavel/page";
import ArtigoNike from "../pages/artigo/melhores-links-nike-cssbuy/page";
import ArtigoJordan from "../pages/artigo/jordan-cssbuy-spreadsheet/page";
import ArtigoYeezy from "../pages/artigo/melhores-yeezy-cssbuy/page";
import ArtigoSuperbuy from "../pages/artigo/cssbuy-vs-superbuy/page";
import ArtigoPandabuy from "../pages/artigo/cssbuy-vs-pandabuy/page";
import ArtigoChina from "../pages/artigo/como-comprar-da-china-cssbuy/page";
import ArtigoFrete from "../pages/artigo/cssbuy-custos-frete-envio/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/artigo/cssbuy-spreadsheet-guia-completo",
    element: <ArtigoGuiaCompleto />,
  },
  {
    path: "/artigo/como-usar-cssbuy-2026",
    element: <ArtigoComoUsar />,
  },
  {
    path: "/artigo/cssbuy-e-seguro-confiavel",
    element: <ArtigoSeguro />,
  },
  {
    path: "/artigo/melhores-links-nike-cssbuy",
    element: <ArtigoNike />,
  },
  {
    path: "/artigo/jordan-cssbuy-spreadsheet",
    element: <ArtigoJordan />,
  },
  {
    path: "/artigo/melhores-yeezy-cssbuy",
    element: <ArtigoYeezy />,
  },
  {
    path: "/artigo/cssbuy-vs-superbuy",
    element: <ArtigoSuperbuy />,
  },
  {
    path: "/artigo/cssbuy-vs-pandabuy",
    element: <ArtigoPandabuy />,
  },
  {
    path: "/artigo/como-comprar-da-china-cssbuy",
    element: <ArtigoChina />,
  },
  {
    path: "/artigo/cssbuy-custos-frete-envio",
    element: <ArtigoFrete />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;